export default {
  name:'not-found'
}